<article class="supports-details-container">
  <section class="side-menu">
    <app-supports-side-menu></app-supports-side-menu>
  </section>
  <section class="wrapper">
    <router-outlet></router-outlet>
  </section>
</article>
